import React, { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { showHideModalAtom } from '../../../Services/_states/Constant';
import { useRecoilState } from 'recoil';
import { newLeadActions } from '../../../Services/_actions/Machadalo/newLead.actions';

function DownloadModal(props) {
  const NewLeadAction = newLeadActions();
  const [showHideModal, setshowHideModal] = useRecoilState(showHideModalAtom);
  const [uploadFile, setUploadFile] = React.useState([]);

  const uploadCommentFile = async () => {
    const formData = new FormData();

    formData.append('file', uploadFile);
    await NewLeadAction.uploadCommentFile(formData);
  };
  return (
    <>
      <Modal
        show={showHideModal.download.show}
        onHide={(e) => {
          setshowHideModal({ ...showHideModal, download: { show: false } });
        }}
        className="wpModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Download/Upload</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="formFile" className="mb-3">
            <div className="form-out-box">
              <Form.Label>Upload Comments :</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => {
                  setUploadFile(e.target.files[0]);
                }}
              />
              <div className="action-icon">
                <span
                  className="action-icon-item"
                  onClick={(e) => {
                    uploadCommentFile();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-cloud-arrow-up-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 5.146a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0z" />
                  </svg>{' '}
                </span>
              </div>
            </div>
            <div className="form-out-box">
              <Form.Label>Download Lead Summary:</Form.Label>
              <div className="action-icon">
                <span
                  className="action-icon-item"
                  onClick={(e) => {
                    NewLeadAction.downloadLeadsSummary(showHideModal.download.data.campaign_id);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-cloud-arrow-down-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708" />
                  </svg>
                </span>
              </div>
            </div>
          </Form.Group>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default DownloadModal;
